import { OperacaoPgtoEnum } from "../enums/operacao-pgto.enum";

export class SangriaSuprimentoRequest {
    constructor() {
        this.codigoFormaPgto = 1;
        this.valor = 0;
    }

    public numeroCaixa: number;
    public codigoFormaPgto: number;
    public motivo: string;
    public operacao: OperacaoPgtoEnum;
    public valor: number;
}